import { SessionStorageService } from 'ngx-webstorage';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { FormService } from './form.service';
import { SharedService } from './shared.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ProposalService } from './proposal.service';
import { LocalStorageService } from 'ngx-localstorage';
import { NormalizeUrlService } from '@allianz/ngx-aem-integration';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { KpiEnum } from '../interfaces/kpi.enum';
import { FormBuilder } from '@angular/forms';
import { LoadedFromCPService } from './loaded-from-customer-portal.service';

@Injectable({
  providedIn: 'root',
})
export class LoadOfferService {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private sharedService: SharedService,
    private formService: FormService,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private localStorage: LocalStorageService,
    private proposalService: ProposalService,
    private sessionService: SessionStorageService,
    private loadedFromCPService: LoadedFromCPService
  ) {
    this.sharedService.isOfferFromEmail =
      this.sessionService.retrieve('isOfferFromEmail');
  }

  public loadOffer(response) {
    const offer = response[0];
    const currentForm = this.formService.getMainForm();
    this.sharedService._routeHistory = this.setRouteHistory(offer.offerScreen);
    this.route.queryParams.subscribe((params) => {
      if(params['language']){
        const lang = params['language'].toLowerCase();
        this.localStorage.set('language', lang);
        this.translateService.use(lang);
        this.sharedService.updateEnums(NormalizeUrlService);
      }
      if(params['email'] == 'CP'){
        this.loadedFromCPService._isCustomerPortal = true;
        this.sharedService.loadedFromCP = true;
      }
    });
    this.sharedService.isAlreadyLoadedOffer = false;
    currentForm.patchValue(offer);
   offer.selectedPayments = offer.selectedPayments.toString();
   currentForm.controls.policyholderData.patchValue(this.setPolicyHolderInfo(offer));
   currentForm.controls.ownerData.patchValue(this.setOwnerInfo(offer));
   currentForm.controls.saveOfferOwnerData.patchValue(this.setSaveOwnerOfferInfo(offer));
   this.setFirstFirstNameAndMobile(currentForm,offer)
   this.setPackageDetailsInfo(currentForm, offer);
   this.setAgent(currentForm, offer);
   this.setFinalDetails(currentForm,offer);
   //this.setAgreements(currentForm, offer)

    return {currentFormData : currentForm} ;
  }

  setRouteHistory(offerScreen){

    let routeHistory = [
    '/start',
    '/object-details',
    '/object-details-2',
    '/package-selection',
    '/object-additional-details',
    '/contact-details',
    '/contact-details-2',
    '/summary',
    '/consents'
  ]

  let splitIndex; 

    switch (offerScreen) {
      case 'FINAL_OPTIONS':
        splitIndex=5;
        break;
      case 'OWNER_FINAL_DETAILS':
        splitIndex=6;
        break
      case 'INSURER_FINAL_DETAILS':
        splitIndex=7;
        break;
      case 'CONFIRMATION':
        splitIndex=8;
        break
      case 'AGREEMENTS':
        splitIndex=9;
        break
      default:
        splitIndex=4;
    }


    return routeHistory.slice(0, splitIndex)

  }


  setPolicyHolderInfo(offerData){
   let policyholderData = {
        email:  offerData.insuredEmail || null,
        countryCode:   offerData.insuredMobilePrefix || null ,
        phoneNumber:  offerData.insuredMobile|| null,
        cityName:  offerData.insuredCity|| null,
        egn:  offerData.insuredEgn|| null,
        firstName: offerData.insuredFirstName || null,
        middleName:  offerData.insuredMiddleName|| null,
        lastName:  offerData.insuredLastName|| null,
        postCode:   offerData.insuredPostCode|| null,
        address: offerData.insuredAddress|| null
      }
      
      return  policyholderData;

  }

  setOwnerInfo(offerData){
    let ownerData = {
        email: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredEmail || null) : (offerData.ownerEmail || null),
        countryCode: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredMobilePrefix || '+359') : (offerData.ownerMobilePrefix || '+359'),
        phoneNumber: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredMobile || null) : (offerData.ownerMobile  || null),
        cityName: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredCity || null) : (offerData.ownerCity || null),
        egn: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredEgn || null) : (offerData.ownerEgn || null),
        firstName: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredFirstName  || null): (offerData.ownerFirstName || null),
        middleName: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredMiddleName || null) : (offerData.ownerMiddleName || null),
        lastName: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredLastName || null) : (offerData.ownerLastName || null),
        postCode: this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredPostCode  || null): (offerData.ownerPostCode || null),
        address:this.isSameOwnerAndInsurer(offerData) ? (offerData.insuredAddress || null) : (offerData.ownerAddress || null)
      }
      
      return ownerData

  }

  setAgreements(currentForm, offerData){
    currentForm.controls.agreement.controls.agreement2.setValue(offerData.emailCommunicationAgreement !== null ? (offerData.emailCommunicationAgreement=='T' ? 1 : 0) : null )
  }


  setSaveOwnerOfferInfo(offerData){
   let saveOfferOwnerData ={
        email: offerData.emailSaveOffer,
        firstName: offerData.firstNameSaveOffer,
        lastName: offerData.surNameSaveOffer,
        countryCode: offerData.mobileCodeSaveOffer,
        phoneNumber: offerData.mobilePhoneSaveOffer,
      }
      return saveOfferOwnerData
  }

  setFirstFirstNameAndMobile(currentForm,offerData){
    currentForm.controls.firstPhoneNumber.setValue(offerData.mobilePhoneSaveOffer);
    currentForm.controls.firstFirstName.setValue(offerData.firstNameSaveOffer);
    currentForm.controls.firstCountryCode.setValue(offerData.mobileCodeSaveOffer);
  }

  setPackageDetailsInfo(currentForm, offerData){
    currentForm.isDeductibleIncluded =offerData.isDeductibleIncluded;
    currentForm.controls.isGlassIncluded.setValue(offerData.isGlassIncluded);
    currentForm.controls.isGoMaxIncluded.setValue(offerData.isGoMaxIncluded);
    currentForm.isEarthQuakeIncluded = offerData.isEarthQuakeIncluded;
    currentForm.selectedPayments = offerData.selectedPayments.toString()
    currentForm.selectedPackageId = offerData.chosenPackageId;
    if (offerData.isGoMaxIncluded === true || offerData.isGoMaxIncluded === 'T') {
      this.sharedService.increaseLimitTicked = true;
      this.sharedService.savedGlassMin = offerData.glass / 10;
      this.sharedService.savedMTPLMin = offerData.goLimit / 3;
    }
  }

  setAgent(currentForm, offerData){
    currentForm.nIDAgent = offerData.agentId
  }

  setFinalDetails(currentForm, offerData){
  
    currentForm.insuranceStart = offerData.insuranceStartDate!=(null || undefined) ? (moment.utc(offerData.insuranceStartDate, "DD.MM.YYYY").local().format()) : null;
    currentForm.isPropertyAddressSameAsCorrespondence = offerData.sameCorrespondenceAddress!==(null || undefined) ? (offerData.sameCorrespondenceAddress==true ? 'Y' : 'N') : null
    currentForm.samePerson = offerData.sameOwnerInsured!==(null || undefined) ? (offerData.sameOwnerInsured==true ? 'Y' : 'N') : null
    currentForm.isFinancedThroughLoan = offerData.propertyBoughtWithLoan!==(null || undefined) ? (offerData.propertyBoughtWithLoan==true ? 'Y' : 'N') : null
    if(offerData.propertyBoughtWithLoan==true){
      this.sharedService.bnfBank$.pipe(map((banks:any) => banks.find(bank => bank.id === offerData.propertyLoanBankName))).subscribe(res => {
        currentForm.controls.companyBeneficiaryData.value = res;
      });
    }

  }

  isSameOwnerAndInsurer(offer){
    return offer?.sameOwnerInsured == true ? true : false
  }


}